import { IconV2 } from 'components/common/IconV2/IconV2';
import type { SmallIconV2Props } from 'components/common/IconV2/IconV2.types';

const HeartOutlineSmallIcon = (props: SmallIconV2Props) => (
  <IconV2 {...props} viewBox="0 0 16 16">
    <path
      stroke="currentcolor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M11.757 10.752c.811-.693 1.513-1.368 1.806-1.842.446-.72.761-1.508.709-2.548C14.179 4.52 12.76 3 11.022 3c-1.708 0-3.05 2.022-3.05 2.022S6.631 3 4.922 3c-1.738 0-3.157 1.52-3.25 3.362-.052 1.04.263 1.828.71 2.548.895 1.445 5.586 4.76 5.59 4.757.002 0 .746-.524 1.699-1.247Z"
    />
  </IconV2>
);

export default HeartOutlineSmallIcon;
